import React from 'react';
import Header from './Common/header';
import './css/index';

export default class Content_25 extends React.Component {
    render() {
        const { data = {}, eid } = this.props;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@lwr8ps`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div className="ant-spin-nested-loading">
                            <div className="ant-spin-container">
                                <div className="portal-element-doc-content" id="__content__60646">
                                    <meta name="GENERATOR" content="Weaver DHTML Editing Control" />
                                    <title />
                                    <p>泛微必须要最专业的成员来推进。</p>
                                    <p>如果你一个月不能成为专业不要紧，如果两个月不能成为专业也不是要紧的事情，但你必须让大家看到你在往前走。</p>
                                    <p>但如果我们走完一年以后，还不专业，那我们就可能已经被竞争对手打死在角落里了。</p>
                                    <p>希望每位同事能真正能理解专业的含义：</p>
                                    <p><strong>专业是一种精神，一种力求完美的精神！</strong></p>
                                    <p><strong>对一个专业的销售人员来说，</strong>所有与你打交道的客户都认为你是一位值得信任的朋友，你能真正为你的客户提出能解决问题的方案，你能为每一个客户提出的问题作出正确回答，并回答利索，并且点面结合。更重要的是一位专业的销售人员能让你的竞争对手叹服，这就需要我们每一天的积累，同时要懂得总结我们工作中碰到的各类问题，然后带着这样的问题，去问懂的人，去仔细查阅相关资料，直到这个问题相关的其它问题都能被弄清楚，这样的销售人员必定会长进飞速。
                                    </p>
                                    <p>对一个专业的销售人员来说，始终能把握问题的关键，懂得怎样利用好公司和自己的资源，能独当一面的去开拓市场。</p>
                                    <p>但客户请你过去传授你的解决方案的时候，你就是一位专业的销售人员！</p>
                                    <p><strong>对一位专业的软件工程师</strong>，能积极寻求“软件功能”实现的商业逻辑答案，然后反复推敲功能实现的合理性和扩展性，懂得别人在使用你所编织的软件来管理公司的关键业务所承载的重大责任。
                                    </p>
                                    <p>专业的软件工程师永远会觉得自己编织的软件存在这样那样的问题，始终在盘算怎么样才能使自己的软件达到最完美的境界。专业的软件工程师必将时刻关注技术的最新发展情况，使自己的知识一直在这个行业内的顶点。</p>
                                    <p>专业的软件工程师一定具备系统的分析能力和系统的设计能力，并能把自己的项目用详尽的文档表达出来，让同一TEAM的软件工程师能行轻松理解的设计思路而不会产生不同的理解。</p>
                                    <p>我们每一天的工作都提供了我们一种机会，一种能让自己成为一位专业人事的机会，所以专业人士必定懂得自己每天使命，必定知道明天他将要实现什么，靠着他/她的勤奋和好胜！</p>
                                    <p>&nbsp;</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_25.js